import PropTypes from "prop-types";

export function Separator({ teeTime, showTime, teeTimeString }) {
  return (
    <div
      style={{
        height: 18,
        backgroundColor: "#1B4F6D",
        width: "100%",
        alignItems: "center",
        display: "flex",
      }}
    >
      {showTime && (
        <div
          className="scorecardItem--separator-title"
          style={{ marginLeft: 16 }}
        >
          {teeTime ?? teeTimeString}
        </div>
      )}
    </div>
  );
}
Separator.propTypes = {
  teeTime: PropTypes.string,
  showTime: PropTypes.bool,
  teeTimeString: PropTypes.string,
};
Separator.defaultProps = {
  teeTime: null,
  showTime: false,
  teeTimeString: "",
};
